/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xi2idpf%7Bright%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1cicglyw%3A%3A-webkit-scrollbar%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1rus1l7x%3Abefore%7Bbackground-color%3Avar(--ds-border%2C%230b120e24)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kfgtyh40%3Abefore%7Bheight%3A2px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._oounu2gc%3Abefore%7Bright%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._qnecu2gc%3Abefore%7Bleft%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1mp41kw7%3Abefore%7Bwidth%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1cs8stnw%3Abefore%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._19woidpf%3Abefore%7Bbottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1kt9b3bt%3Abefore%7Bcontent%3A%22%22%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._fntnidpf%3Abefore%7Bmargin-left%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._zr3eidpf%3Abefore%7Bmargin-bottom%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._eid3idpf%3Abefore%7Bmargin-right%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._pascidpf%3Abefore%7Bmargin-top%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._rfx3lb4i%3Abefore%7Bborder-radius%3Avar(--ds-radius-xsmall%2C2px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1fjgglyw%7Bscrollbar-width%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1dm8q5uf%7Bscroll-behavior%3Asmooth%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo1wug%7Boverflow-x%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bh4vqrj%7Bscroll-padding%3A0%2024px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ltvidpf%7Bleft%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkvuon%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pby18h8%7Bz-index%3A999%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._154i1b66%7Btop%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1dze261p%20%5Brole%3Dtab%5D%7Btext-overflow%3Aunset%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1fud261p%20%5Brole%3Dtab%5D%7Boverflow-y%3Aunset%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._7hip261p%20%5Brole%3Dtab%5D%7Boverflow-x%3Aunset%21important%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18q9glyw%20%5Brole%3Dtablist%5D%3Abefore%7Bdisplay%3Anone%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
import React, { useCallback, useMemo, useRef, useState } from 'react';
import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import { calculateConditionalButtons, type ConditionalButtons, createGhost, getTabList, scrollBack, scrollForward } from './scrolling-tabs';
function isTouchDevice() {
  return 'ontouchstart' in window ||
  // eslint-disable-next-line compat/compat
  navigator.maxTouchPoints > 0;
}
type ScrollingTabListProps = {
  children: JSX.Element;
};
const initialConditionalButtonsState: ConditionalButtons = {
  back: false,
  forward: false
};
const scrollingContainerStyles = null;
const containerStyles = null;
const backButtonStyles = null;
const nextButtonStyles = null;

/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */
export const ScrollingTabList = (props: ScrollingTabListProps): JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const [conditionalButtons, setConditionalButtons] = useState<ConditionalButtons>(initialConditionalButtonsState);
  const ghost = useMemo(() => createGhost(), []);
  const onTabClick = useCallback((e: Event) => {
    const target = (e.currentTarget as Element);
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }, []);
  React.useLayoutEffect(() => {
    const container = ref.current;
    let scrollingContainer: HTMLElement | null | undefined;
    let tabs: Element[];
    const handleConditionalButtonsChange = () => {
      const buttons = calculateConditionalButtons(scrollingContainer, isTouchDevice());
      setConditionalButtons(buttons);
    };
    const observerCallback: MutationCallback = mutationList => {
      const tablist = getTabList(ref);
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          const addedNodes = (Array.from(mutation.addedNodes) as HTMLElement[]);
          const found = addedNodes.find(node => node.getAttribute('role') === 'tab');
          if (found && tablist) {
            ghost.remove();
            const tabs = Array.from(tablist.children);
            tabs.forEach(tab => {
              tab.removeEventListener('click', onTabClick);
              tab.addEventListener('click', onTabClick);
            });
            tablist.appendChild(ghost);
            handleConditionalButtonsChange();
          }
        }
      }
    };
    const observer = new MutationObserver(observerCallback);
    if (container) {
      const tablist = getTabList(ref);
      scrollingContainer = tablist?.parentElement;
      observer.observe(container, {
        attributes: false,
        childList: true,
        subtree: true
      });
      if (scrollingContainer instanceof HTMLElement && tablist) {
        tablist.appendChild(ghost);
        tabs = Array.from(tablist.children);
        tabs.forEach(tab => tab.addEventListener('click', onTabClick));
        handleConditionalButtonsChange();
        scrollingContainer.addEventListener('scroll', handleConditionalButtonsChange);
      }
      return () => {
        if (scrollingContainer) {
          // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
          scrollingContainer.removeEventListener('scroll', handleConditionalButtonsChange);
        }
        if (tabs.length) {
          tabs.forEach(tab => tab.removeEventListener('click', onTabClick));
        }
      };
    }
  }, [onTabClick, ghost, ref]);
  const buttonProps: Partial<IconButtonProps> = {
    appearance: 'subtle',
    spacing: 'compact'
  };
  return <div ref={ref} data-testid="scrolling-tabs" className={ax(["_kqswh2mm _18q9glyw _7hip261p _1fud261p _1dze261p"])}>
			{conditionalButtons.back && <div className={ax(["_kqswstnw _154i1b66 _1pby18h8 _bfhkvuon _1ltvidpf", "back"])}>
					<IconButton data-test-id="back" onClick={() => scrollBack(ref)} label="back" icon={iconProps => <ChevronLeftIcon {...iconProps} size="small" />} {...buttonProps} />
				</div>}
			<div className={ax(["_1bh4vqrj _1reo1wug _1dm8q5uf _1fjgglyw _rfx3lb4i _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1kt9b3bt _19woidpf _1cs8stnw _1mp41kw7 _qnecu2gc _oounu2gc _kfgtyh40 _1rus1l7x _1cicglyw"])}>{props.children}</div>
			{conditionalButtons.forward && <div className={ax(["_kqswstnw _154i1b66 _1pby18h8 _bfhkvuon _1xi2idpf"])}>
					<IconButton data-test-id="forward" onClick={() => scrollForward(ref)} {...buttonProps} label="forward" icon={iconProps => <ChevronRightIcon {...iconProps} size="small" />} />
				</div>}
		</div>;
};